import React, { useEffect, useState } from 'react';
import api, { getErrorMessage } from '../../services/api';
import { toast } from 'react-toastify';

/**
 * Filtro por cliente para un despacho o un abogado en Reclamaciones. Ofrece solo
 * sus clientes (`GET /expedients/partner-clients`), que son los mismos con los
 * que el listado valida `?cliente=`: nada de lo que sale aquí da 403.
 */
function PartnerClientSelect({ selectedUser, onUserChange }) {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/expedients/partner-clients')
      .then(({ data }) => setClients(data.data || []))
      .catch(err => toast.error(getErrorMessage(err)))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className='text-sm text-gray-500'>Cargando clientes…</p>;

  return (
    <select
      id='partnerClientFilter'
      aria-label='Cliente'
      className='block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-lg'
      value={selectedUser}
      onChange={e => onUserChange(e.target.value)}
    >
      <option value=''>Todos los clientes</option>
      {clients.map(c => (
        <option key={c._id} value={c._id}>
          {c.username || c.usermail}
        </option>
      ))}
    </select>
  );
}

export default PartnerClientSelect;
